export const isValidUSPhoneNumber = (digits: string) => {
    return digits.split('').length === 11;
}

export const validatePhoneNumber = (digits: string) => {
    return isValidUSPhoneNumber(digits) && digits?.toString().startsWith("1")
}